import SubNavTitle from './SubNavTitle';

export default SubNavTitle;
